export const goToGettingStarted = async (evt) => {
    window.location.href = "/starting";
}